export default {"src":"/_next/static/media/cxr2.18284b1f.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};